// extracted by mini-css-extract-plugin
export default {"colleges":"college_colleges__fdxJG","collegeList":"college_collegeList__MGd0f","app-content":"college_app-content__VIIQG"};